import script from "./DangKy.vue?vue&type=script&lang=ts&setup=true"
export * from "./DangKy.vue?vue&type=script&lang=ts&setup=true"

import "./DangKy.vue?vue&type=style&index=0&id=2a07553f&lang=css"

const __exports__ = script;

export default __exports__